/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForIdentityOntologyEventSync extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForIdentityOntologyEventSync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForIdentityOntologyEventSync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForIdentityOntologyEventSync>): BackgroundJobPayloadForIdentityOntologyEventSync {
        let obj = Object.assign(new BackgroundJobPayloadForIdentityOntologyEventSync(), model);
        BackgroundJobPayloadForIdentityOntologyEventSync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForIdentityOntologyEventSync>): BackgroundJobPayloadForIdentityOntologyEventSync {
        if (!model) return null;
        return BackgroundJobPayloadForIdentityOntologyEventSync.newInstance(<BackgroundJobPayloadForIdentityOntologyEventSync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForIdentityOntologyEventSync) {
        if (!obj) return;

        models.BackgroundJobPayloadForIdentityOntologyEventSync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForIdentityOntologyEventSync): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForIdentityOntologyEventSync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * CoreStack master account (GraphDB repo scope) the changed entity belongs to.
     */
    master_account_id: string;

    /**
     * Which ontology class the changed entity projects to.
     */
    entity_type: models.IdentityOntologyEntityType;

    /**
     * Mongo _id of the changed AccountMaster / Tenant / ServiceAccount document.
     */
    entity_id: string;

    /**
     * upsert: fetch current state and full-subject-replace. delete: remove the subject (and its embedded children) from GraphDB.
     */
    operation: models.IdentityOntologyEventOperation;

}
